/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ExpenseBatchResource } from './';
import {
    ExpenseBatchResourceFromJSON,
    ExpenseBatchResourceFromJSONTyped,
    ExpenseBatchResourceToJSON,
} from './';
import type { ExpenseListResourceSummary } from './';
import {
    ExpenseListResourceSummaryFromJSON,
    ExpenseListResourceSummaryFromJSONTyped,
    ExpenseListResourceSummaryToJSON,
} from './';
import type { ExpenseResource } from './';
import {
    ExpenseResourceFromJSON,
    ExpenseResourceFromJSONTyped,
    ExpenseResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExpenseListResource
 */
export interface ExpenseListResource {
    /**
     * 
     * @type {ExpenseListResourceSummary}
     * @memberof ExpenseListResource
     */
    summary: ExpenseListResourceSummary;
    /**
     * The expenses outside the returned batches. While no batch is returned, every expense of the project.
     * @type {Array<ExpenseResource>}
     * @memberof ExpenseListResource
     */
    expenses: Array<ExpenseResource>;
    /**
     * 
     * @type {Array<ExpenseBatchResource>}
     * @memberof ExpenseListResource
     */
    batches: Array<ExpenseBatchResource>;
}

/**
 * Check if a given object implements the ExpenseListResource interface.
 */
export function instanceOfExpenseListResource(value: object): value is ExpenseListResource {
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('expenses' in value) || value['expenses'] === undefined) return false;
    if (!('batches' in value) || value['batches'] === undefined) return false;
    return true;
}

export function ExpenseListResourceFromJSON(json: any): ExpenseListResource {
    return ExpenseListResourceFromJSONTyped(json, false);
}

export function ExpenseListResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseListResource {
    if (json == null) {
        return json;
    }
    return {
        
        'summary': ExpenseListResourceSummaryFromJSON(json['summary']),
        'expenses': ((json['expenses'] as Array<any>).map(ExpenseResourceFromJSON)),
        'batches': ((json['batches'] as Array<any>).map(ExpenseBatchResourceFromJSON)),
    };
}

export function ExpenseListResourceToJSON(value?: ExpenseListResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'summary': ExpenseListResourceSummaryToJSON(value['summary']),
        'expenses': ((value['expenses'] as Array<any>).map((v) => ExpenseResourceToJSON(v))),
        'batches': ((value['batches'] as Array<any>).map((v) => ExpenseBatchResourceToJSON(v))),
    };
}

